const sickness = {
  getlist: 'sickness/getlist',
  add: 'sickness/add',
  update: 'sickness/update',
  remove: 'sickness/remove',
  get: 'sickness/get',
  getall: 'sickness/getall',
}
export default sickness
